// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@awc/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { listStyles } from "@awc/Overrides/Widgets/MyLists/MyListsList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

listStyles.messageText = {
    ...dataTableStyles.noResultsText,
};

listStyles.notifyWrapper = {
    css: css`
        width: 100%;
        display: flex;
        align-items: flex-start;
        margin-top: 8px;
    `,
};

listStyles.cardList = {
    gridContainer: {
        gap: 0,
    },
};

listStyles.cardContainer = {
    cardDivider: {
        css: css`
            width: 100%;
            margin: 0;
            padding: 12px;
            border: 1px solid ${getColor("common.border")};
            border-top: 6px solid ${getColor("secondary.main")};

            &:not(:last-child) {
                margin-bottom: 10px;
            }
        `,
    },
};

listStyles.wishlistCard = {
    actionAddToCartButton: {
        variant: "addToCart" as any,
    },
};

listStyles.deleteListModalStyles = {
    container: {
        gap: 24,
    },
};
